import styled from "styled-components";
import { colors } from "@sonder/ui/source/styled/theme";

export const VideoPlayer = styled.video`
  background: ${colors.black};
`;
